import { render, staticRenderFns } from "./mainbusinessPage4.vue?vue&type=template&id=c73df672&scoped=true&"
import script from "./mainbusinessPage4.vue?vue&type=script&lang=js&"
export * from "./mainbusinessPage4.vue?vue&type=script&lang=js&"
import style0 from "./mainbusinessPage4.vue?vue&type=style&index=0&id=c73df672&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73df672",
  null
  
)

export default component.exports